import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import type { DashboardLinkIconCardProps } from '@/components/dashboard/DashboardLinkIconCard';
import { DashboardLinkIconCard } from '@/components/dashboard/DashboardLinkIconCard';
import { routes } from '@/routes/routes';
import {
  DeliveryTruck as DeliveryTruckIcon,
  Flash as FlashIcon,
  Medication as MedicationIcon,
  RuleLocked as RuleLockedIcon,
} from '@carbon/icons-react';

const helpCards: Array<DashboardLinkIconCardProps> = [
  {
    Icon: FlashIcon,
    title: 'Getting Started',
    description: 'Learn the basics of who we are, and how to sign up.',
    to: routes.help.gettingStarted,
  },
  {
    Icon: DeliveryTruckIcon,
    title: 'Shipping & Packaging',
    description:
      'We ship in discrete packaging all over the continental Europe.',
    to: routes.help.shipping,
  },
  {
    Icon: RuleLockedIcon,
    title: 'Safety & Privacy',
    description:
      'Protecting your information and your health is our top priority.',
    to: routes.help.safetyPrivacy,
  },
  {
    Icon: MedicationIcon,
    title: 'Supplements & Refills',
    description: 'Access your supplement information anytime, anywhere.',
    to: routes.help.supplementsRefills,
  },
];

export const HelpPage = () => {
  return (
    <Section containerClassName="pt-0" className="max-w-254">
      <Heading as="h1" className="text-secondary mb-7.5 lg:mb-13">
        How can we help?
      </Heading>

      <CardsContainer className="-mx-4 grid grid-cols-1 lg:mx-0 lg:grid-cols-2 lg:gap-3 lg:px-12">
        {helpCards.map(({ Icon, title, description, to }) => (
          <DashboardLinkIconCard
            key={title}
            Icon={Icon}
            title={title}
            description={description}
            to={to}
            limitDescriptionLength
          />
        ))}
      </CardsContainer>
    </Section>
  );
};
